<div class="wh-shell d-flex align-items-center justify-content-between flex-wrap gap-2 px-2 py-1">
  <!-- Left: title + total -->
  <div class="d-flex align-items-center gap-2">
    <span class="wh-title">{{ title }}</span>
    <span *ngIf="showTotalValue" class="wh-total">{{ totalValue || 0 }}</span>
  </div>

  <!-- Right: filters -->
  <div class="d-flex align-items-center gap-1">
    <div *ngIf="isChartTypeFilter" class="wh-select">
      <mat-form-field appearance="outline" class="wh-field">
        <mat-select
          [(ngModel)]="selectedChartTypeFilterValue"
          name="chartTypeFilter"
          (selectionChange)="onChartTypeSelectionChange($event)"
        >
          <mat-option *ngFor="let option of chartTypeFilterOptions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="isDateTypeFilter" class="wh-select">
      <mat-form-field appearance="outline" class="wh-field">
        <mat-select
          [(ngModel)]="selectedDateFilterValue"
          name="dateFilter"
          (selectionChange)="onDateSelectionChange($event)"
        >
          <mat-option *ngFor="let option of dateFilterOptions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
